'use strict';

require('../../style/index.css');

require('../../grid/style/index.css');


//////////////////
// WEBPACK FOOTER
// ./~/_antd@2.13.2@antd/lib/col/style/css.js
// module id = 1011
// module chunks = 0